import { CSSTransitionClassNames } from 'react-transition-group/CSSTransition'
import { css } from 'styled-components'

import { down } from '@Globals/Style/breakpoints'

const menuTransitionTime = '0.15s'

export const slideInLeftClasses = (withDelay: boolean): CSSTransitionClassNames => ({
  enter: 'enter',
  enterActive: 'enter-active',
  exit: 'exit',
  exitActive: withDelay ? 'exit-active-with-delay' : 'exit-active',
})

export const slideInLeft = css`
  &.enter {
    transform: translateX(-610px);
    ${down('desktop')} {
      transform: translateX(-330px);
    }
  }

  &.enter-active {
    transform: translateX(0);
    transition: transform ${menuTransitionTime} cubic-bezier(0.25, 0.45, 0.45, 0.94);
  }

  &.exit {
    transform: translateX(0);
  }

  &.exit-active {
    transform: translateX(-610px);
    transition: transform ${menuTransitionTime} cubic-bezier(0.55, 0.085, 0.68, 0.53);
    ${down('desktop')} {
      transform: translateX(-330px);
    }
  }

  &.exit-active-with-delay {
    transform: translateX(-610px);
    transition: transform ${menuTransitionTime} cubic-bezier(0.55, 0.085, 0.68, 0.53) 0.1s;
    ${down('desktop')} {
      transform: translateX(-330px);
    }
  }
`

export const showFloatingMobileHeaderClasses = (): CSSTransitionClassNames => ({
  enter: 'enter',
  enterActive: 'enterActive',
})

export const showFloatingMobileHeader = css`
  .enter {
    transform: translateY(-140px);
  }

  .enterActive {
    transform: translateY(0px);
    transition: transform 0.125s ease-in-out;
  }
`

export const fadeClasses = (): CSSTransitionClassNames => ({
  enter: 'enter',
  enterActive: 'enterActive',
  exit: 'exit',
  exitActive: 'exitActive',
})

export const fade = css`
  .enter {
    opacity: 0;
  }

  .enterActive {
    opacity: 1;
    transition: opacity 0.125s ease-in-out;
  }

  .exit {
    opacity: 1;
  }

  .exitActive {
    opacity: 0;
    transition: opacity 0.125s ease-in-out;
  }
`
